import React from 'react';
import {
  SingleHistoricCallLocation,
  SingleHistoricAlertLocation,
} from '../Location';
import {
  HistoricWrapper,
  HistoricWrapperContent,
  InnerWrapper,
} from './styles/Locations.styles';

const HistoricLocations = ({ locations = [], selectedAlertID }) => {
  if (locations.length <= 1) return null;

  const generateUniqueKey = location => {
    if (location.extra_info) {
      return location.extra_info.payload_id;
    } else if (location.caller_id) {
      return `${location.caller_id}-${location.location_time}`;
    }
    return `${selectedAlertID}-${location.created_at}`;
  };

  return (
    <HistoricWrapper p={'0'} expanded>
      <InnerWrapper>
        <HistoricWrapperContent expanded shouldReverse={locations[0].caller_id}>
          {locations.map((location, locationIndex) =>
            location.caller_id ? (
              locationIndex !== locations?.length - 1 ? (
                <SingleHistoricCallLocation
                  key={generateUniqueKey(location)}
                  {...{
                    location,
                    locationIndex,
                  }}
                />
              ) : null
            ) : !location.caller_id ? (
              locationIndex > 0 ? (
                <SingleHistoricAlertLocation
                  key={generateUniqueKey(location)}
                  {...{ location, locationIndex }}
                />
              ) : null
            ) : null,
          )}
        </HistoricWrapperContent>
      </InnerWrapper>
    </HistoricWrapper>
  );
};

export default HistoricLocations;
